import { BrowserModule } from "@angular/platform-browser";
import { NgModule } from "@angular/core";
import { HttpClientModule, HttpClient } from "@angular/common/http";
import { AppComponent } from "./app.component";
import { FlexLayoutModule } from "@angular/flex-layout";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { AuthModule } from "./auth/auth.module";
import { MainModule } from "./main/main.module";
import { NetworkService } from "./shared/network.service";
import { CommonService } from "./shared/common.service";
import { AuthGuardMain } from "./auth/auth-guard.service";
import { AppRoutingModule } from "./app.routing";
import { Routes, RouterModule } from "@angular/router";
import { NgbModule } from "@ng-bootstrap/ng-bootstrap";
import { Ng2TelInputModule } from "ng2-tel-input";
import { SharedModule } from "../app/shared/shared.module";
import { GoogleChartsModule } from "angular-google-charts";
import { VendorManagementComponent } from './vendor-management/vendor-management.component';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';

const routes: Routes = [
  { path: "", redirectTo: "auth/login", pathMatch: "full" },
];

@NgModule({
  declarations: [AppComponent],
  imports: [
    AuthModule,
    BrowserModule,
    BrowserAnimationsModule,
    FlexLayoutModule,
    HttpClientModule,
    MainModule,
    NgbModule,
    AppRoutingModule,
    Ng2TelInputModule,
    SharedModule,
    GoogleChartsModule,
    RouterModule.forRoot(routes),
    InfiniteScrollModule
  ],
  providers: [NetworkService, CommonService, AuthGuardMain, NetworkService],

  bootstrap: [AppComponent],
})
export class AppModule {}
